// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"ed43954a","453":"8e315bf6"}[chunkId] + ".chunk.js";
};